/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:02 PM
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ContentSystemGridViewModel = require("content-models/system/ContentSystemGridViewModel");

    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var OrganizeCollectionDecorator = require("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");
    var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");
    var Constant = require("content-config/constant.json");

    var ContentSystemTablePageModel = {};

    //list of keys on the Content JSON instead of repeating strings everywhere  baha ha ha ha
    var KEYS = {
        type: "type",
        selectable: "collections.selectable",
        organized: "collections.organized",
        gridViewModel: "collections.gridViewModel",
        pageInfo: "pageInfo",
        pageInfoTotals: "pageInfo.totalPages",
        pageInfoCurrent: "pageInfo.currentPageNumber",
        pageSize: "pageSize",
        actionsCollection: "actions.collection",
        actionsConfig: "actions.config"
    };

    var TYPES = Constant.CONTENT_TYPES;

    var TYPE_CONF = {};

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {
        ContentSystemTablePageModel = BaseModel.extend({
            name: "ContentSystemTablePageModel",
            defaults: {
                collections: {
                    selectable: {},
                    organized: {},
                    gridViewModel: {}
                },
                actions: {
                    collection: {},
                    config: [
                        {
                            id: "edit",
                            actionName: LE.translator.translate("LEFramework.global.captions.edit"),
                            enabled: false,
                            align: "right"
                        }
                    ]
                },
                pageInfo: {
                    currentPageNumber: 0,
                    totalPages: 1
                },
                pageSize: 25
            },

            initialize: function (options) {
                this.type = options.type;
                TYPE_CONF[TYPES.SYSTEM] =  {
                    collectionName: LEContent.getDataManager().ENTITY_ENUM.SYSTEM
                };
                TYPE_CONF[TYPES.SYSTEM_MESSAGING] =  {
                    collectionName: LEContent.getDataManager().ENTITY_ENUM.SYSTEM_MESSAGING
                };
                this.set(KEYS.selectable, SelectableCollectionDecorator.decorate(LEContent.getDataManager().getData(TYPE_CONF[this.type].collectionName)));
                this.set(KEYS.gridViewModel, new ContentSystemGridViewModel());
                this.set(KEYS.organized, OrganizeCollectionDecorator.decorate(this.getCollection(), {
                    pageSize: this.get(KEYS.pageSize),
                    lazy: true
                }));
                this._initActionsDropdown();
                this._initTypeAndListeners();
            },
            prepData: function (){
                //For the messaging table we need to merge the data for the table
                if ( TYPES.SYSTEM_MESSAGING === this.type ) {
                    this.getOrganizedCollection().unBindFromOriginalCollectionEvents();

                    var defaultsCollection = LEContent.getDataManager().getSystemMessagingDefaultsCollection();
                    var overridesFromACCollection = LEContent.getDataManager().getSystemMessagingCollection();
                    var mergedModels = [];
                    defaultsCollection.each(function (defaultModel) {
                        var override = overridesFromACCollection.get(defaultModel.getEventId());
                        if (_.isEmpty(override)) {
                            mergedModels.push(defaultModel.clone());
                        }
                    });

                    overridesFromACCollection.add(mergedModels);
                    this.getCollection().reset(overridesFromACCollection.models); //somehow updating the original collection does not update the selectable collection

                    this.getOrganizedCollection().bindToOriginalCollectionEvents();
                    this.getOrganizedCollection().organize();
                }
            },

            //init actions according to collection type
            _initActionsDropdown: function () {
                this.set(KEYS.actionsCollection,new DropdownMenu.Collection(this.get(KEYS.actionsConfig)));
            },

            _initTypeAndListeners: function() {
                this.stopListening(this.getCollection());
                this.stopListening(this.getOrganizedCollection());

                this.listenTo(this.getOrganizedCollection() ,"reset", this._onCollectionReset, this); //noam //todo bom - change listening to reset maybe not good??
                this.listenTo(this.getCollection(), "change:selection", this._onSelectionChanged, this);
            },

            _onCollectionReset: function () {
                var info = this.getOrganizedCollection().getPagerInfo();
                this.setContentPageInfo(info);
                this._onSelectionChanged();
            },
            _onSelectionChanged: function () {
                var collection = this.getCollection();
                var selectionLength = collection.getSelectionLength();
                this._setActionAvailability("edit",(selectionLength === 1),"LEContent.content.gallery.menu.action.edit.tooltip");
            },

            _setActionAvailability: function(actionId,enabled,tooltipKey) {
                 var tooltip = enabled? LE.translator.translate(tooltipKey): "";
                 var actionsCollection  = this.getActions();
                 var action =  actionsCollection.get(actionId);
                 if (action) {
                     action.set({"enabled": enabled, "title": tooltip});
                 }
            },

            pageNumberChange: function(currentPageNumber) {
                this.getOrganizedCollection().organize({currentPage: currentPageNumber});
                this.setContentPageInfoCurrentPage(currentPageNumber);
            },

            getType: function() {
                return this.type;
            },
            getActions: function() {
                return this.get(KEYS.actionsCollection);
            },
            getCollection: function() {
                return this.get(KEYS.selectable);
            },
            getOrganizedCollection: function() {
                return this.get(KEYS.organized);
            },
            getGridViewModel: function() {
                return this.get(KEYS.gridViewModel);
            },
            getContentPageInfoTotal: function(){
                return this.get(KEYS.pageInfoTotals);
            },
            getContentPageInfoCurrentPage: function(){
                return this.get(KEYS.pageInfoCurrent);
            },
            setContentPageInfoCurrentPage: function(currentPageIdx){
                this.set(KEYS.pageInfoCurrent,currentPageIdx);
            },
            setContentPageInfo: function(pgInfo){
                return this.set(KEYS.pageInfo,pgInfo);
            }


        });
    });

    ContentSystemTablePageModel.KEYS = KEYS;
    ContentSystemTablePageModel.TYPES = TYPES;

    return ContentSystemTablePageModel;
});
